<sc-padding>

  <app-gate-keeper-control-find-element-by-qr-camera-picker (deviceSelected)="onDeviceSelected($event)" />

  <div class="screen">
    <zxing-scanner #scanner class="scanner" [enable]="scannerEnabled"
                    [device]="deviceCurrent"
                    (scanSuccess)="scanSuccessHandler($event)"
                    (scanError)="scanErrorHandler($event)"></zxing-scanner>
  </div>
</sc-padding>
